/**
 * Generated by orval v8.4.0 🍺
 * Do not edit manually.
 * Messages API
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CreateMessageBody,
  CreateTemplateBody,
  DeleteApiMessagesTemplatesId200,
  GetApiMessagesParams,
  Message,
  Template,
  UpdateTemplateBody
} from './model/messages';





/**
 * @summary List messages
 */
export type getApiMessagesResponse200 = {
  data: Message[]
  status: 200
}

export type getApiMessagesResponseSuccess = (getApiMessagesResponse200) & {
  headers: Headers;
};
;

export type getApiMessagesResponse = (getApiMessagesResponseSuccess)

export const getGetApiMessagesUrl = (params?: GetApiMessagesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/messages?${stringifiedParams}` : `/api/messages`
}

export const getApiMessages = async (params?: GetApiMessagesParams, options?: RequestInit): Promise<getApiMessagesResponse> => {
  
  const res = await fetch(getGetApiMessagesUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
)

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  
  const data: getApiMessagesResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as getApiMessagesResponse
}





export const getGetApiMessagesQueryKey = (params?: GetApiMessagesParams,) => {
    return [
    `/api/messages`, ...(params ? [params] : [])
    ] as const;
    }

    
export const getGetApiMessagesQueryOptions = <TData = Awaited<ReturnType<typeof getApiMessages>>, TError = unknown>(params?: GetApiMessagesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiMessages>>, TError, TData>, fetch?: RequestInit}
) => {

const {query: queryOptions, fetch: fetchOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiMessagesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiMessages>>> = ({ signal }) => getApiMessages(params, { signal, ...fetchOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiMessages>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiMessagesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiMessages>>>
export type GetApiMessagesQueryError = unknown


/**
 * @summary List messages
 */

export function useGetApiMessages<TData = Awaited<ReturnType<typeof getApiMessages>>, TError = unknown>(
 params?: GetApiMessagesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiMessages>>, TError, TData>, fetch?: RequestInit}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiMessagesQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * @summary Create message
 */
export type postApiMessagesResponse201 = {
  data: Message
  status: 201
}

export type postApiMessagesResponseSuccess = (postApiMessagesResponse201) & {
  headers: Headers;
};
;

export type postApiMessagesResponse = (postApiMessagesResponseSuccess)

export const getPostApiMessagesUrl = () => {


  

  return `/api/messages`
}

export const postApiMessages = async (createMessageBody: CreateMessageBody, options?: RequestInit): Promise<postApiMessagesResponse> => {
  
  const res = await fetch(getPostApiMessagesUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createMessageBody,)
  }
)

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  
  const data: postApiMessagesResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as postApiMessagesResponse
}




export const getPostApiMessagesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiMessages>>, TError,{data: CreateMessageBody}, TContext>, fetch?: RequestInit}
): UseMutationOptions<Awaited<ReturnType<typeof postApiMessages>>, TError,{data: CreateMessageBody}, TContext> => {

const mutationKey = ['postApiMessages'];
const {mutation: mutationOptions, fetch: fetchOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, fetch: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiMessages>>, {data: CreateMessageBody}> = (props) => {
          const {data} = props ?? {};

          return  postApiMessages(data,fetchOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiMessagesMutationResult = NonNullable<Awaited<ReturnType<typeof postApiMessages>>>
    export type PostApiMessagesMutationBody = CreateMessageBody
    export type PostApiMessagesMutationError = unknown

    /**
 * @summary Create message
 */
export const usePostApiMessages = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiMessages>>, TError,{data: CreateMessageBody}, TContext>, fetch?: RequestInit}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiMessages>>,
        TError,
        {data: CreateMessageBody},
        TContext
      > => {
      return useMutation(getPostApiMessagesMutationOptions(options));
    }
    
/**
 * @summary Get message detail
 */
export type getApiMessagesIdResponse200 = {
  data: Message
  status: 200
}

export type getApiMessagesIdResponseSuccess = (getApiMessagesIdResponse200) & {
  headers: Headers;
};
;

export type getApiMessagesIdResponse = (getApiMessagesIdResponseSuccess)

export const getGetApiMessagesIdUrl = (id: string,) => {


  

  return `/api/messages/${id}`
}

export const getApiMessagesId = async (id: string, options?: RequestInit): Promise<getApiMessagesIdResponse> => {
  
  const res = await fetch(getGetApiMessagesIdUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
)

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  
  const data: getApiMessagesIdResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as getApiMessagesIdResponse
}





export const getGetApiMessagesIdQueryKey = (id: string,) => {
    return [
    `/api/messages/${id}`
    ] as const;
    }

    
export const getGetApiMessagesIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiMessagesId>>, TError = unknown>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiMessagesId>>, TError, TData>, fetch?: RequestInit}
) => {

const {query: queryOptions, fetch: fetchOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiMessagesIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiMessagesId>>> = ({ signal }) => getApiMessagesId(id, { signal, ...fetchOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiMessagesId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiMessagesIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiMessagesId>>>
export type GetApiMessagesIdQueryError = unknown


/**
 * @summary Get message detail
 */

export function useGetApiMessagesId<TData = Awaited<ReturnType<typeof getApiMessagesId>>, TError = unknown>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiMessagesId>>, TError, TData>, fetch?: RequestInit}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiMessagesIdQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * @summary List message templates
 */
export type getApiMessagesTemplatesResponse200 = {
  data: Template[]
  status: 200
}

export type getApiMessagesTemplatesResponseSuccess = (getApiMessagesTemplatesResponse200) & {
  headers: Headers;
};
;

export type getApiMessagesTemplatesResponse = (getApiMessagesTemplatesResponseSuccess)

export const getGetApiMessagesTemplatesUrl = () => {


  

  return `/api/messages/templates`
}

export const getApiMessagesTemplates = async ( options?: RequestInit): Promise<getApiMessagesTemplatesResponse> => {
  
  const res = await fetch(getGetApiMessagesTemplatesUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
)

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  
  const data: getApiMessagesTemplatesResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as getApiMessagesTemplatesResponse
}





export const getGetApiMessagesTemplatesQueryKey = () => {
    return [
    `/api/messages/templates`
    ] as const;
    }

    
export const getGetApiMessagesTemplatesQueryOptions = <TData = Awaited<ReturnType<typeof getApiMessagesTemplates>>, TError = unknown>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiMessagesTemplates>>, TError, TData>, fetch?: RequestInit}
) => {

const {query: queryOptions, fetch: fetchOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiMessagesTemplatesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiMessagesTemplates>>> = ({ signal }) => getApiMessagesTemplates({ signal, ...fetchOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiMessagesTemplates>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiMessagesTemplatesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiMessagesTemplates>>>
export type GetApiMessagesTemplatesQueryError = unknown


/**
 * @summary List message templates
 */

export function useGetApiMessagesTemplates<TData = Awaited<ReturnType<typeof getApiMessagesTemplates>>, TError = unknown>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiMessagesTemplates>>, TError, TData>, fetch?: RequestInit}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiMessagesTemplatesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * @summary Create template
 */
export type postApiMessagesTemplatesResponse201 = {
  data: Template
  status: 201
}

export type postApiMessagesTemplatesResponseSuccess = (postApiMessagesTemplatesResponse201) & {
  headers: Headers;
};
;

export type postApiMessagesTemplatesResponse = (postApiMessagesTemplatesResponseSuccess)

export const getPostApiMessagesTemplatesUrl = () => {


  

  return `/api/messages/templates`
}

export const postApiMessagesTemplates = async (createTemplateBody: CreateTemplateBody, options?: RequestInit): Promise<postApiMessagesTemplatesResponse> => {
  
  const res = await fetch(getPostApiMessagesTemplatesUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createTemplateBody,)
  }
)

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  
  const data: postApiMessagesTemplatesResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as postApiMessagesTemplatesResponse
}




export const getPostApiMessagesTemplatesMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiMessagesTemplates>>, TError,{data: CreateTemplateBody}, TContext>, fetch?: RequestInit}
): UseMutationOptions<Awaited<ReturnType<typeof postApiMessagesTemplates>>, TError,{data: CreateTemplateBody}, TContext> => {

const mutationKey = ['postApiMessagesTemplates'];
const {mutation: mutationOptions, fetch: fetchOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, fetch: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiMessagesTemplates>>, {data: CreateTemplateBody}> = (props) => {
          const {data} = props ?? {};

          return  postApiMessagesTemplates(data,fetchOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiMessagesTemplatesMutationResult = NonNullable<Awaited<ReturnType<typeof postApiMessagesTemplates>>>
    export type PostApiMessagesTemplatesMutationBody = CreateTemplateBody
    export type PostApiMessagesTemplatesMutationError = unknown

    /**
 * @summary Create template
 */
export const usePostApiMessagesTemplates = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiMessagesTemplates>>, TError,{data: CreateTemplateBody}, TContext>, fetch?: RequestInit}
 ): UseMutationResult<
        Awaited<ReturnType<typeof postApiMessagesTemplates>>,
        TError,
        {data: CreateTemplateBody},
        TContext
      > => {
      return useMutation(getPostApiMessagesTemplatesMutationOptions(options));
    }
    
/**
 * @summary Get template detail
 */
export type getApiMessagesTemplatesIdResponse200 = {
  data: Template
  status: 200
}

export type getApiMessagesTemplatesIdResponseSuccess = (getApiMessagesTemplatesIdResponse200) & {
  headers: Headers;
};
;

export type getApiMessagesTemplatesIdResponse = (getApiMessagesTemplatesIdResponseSuccess)

export const getGetApiMessagesTemplatesIdUrl = (id: string,) => {


  

  return `/api/messages/templates/${id}`
}

export const getApiMessagesTemplatesId = async (id: string, options?: RequestInit): Promise<getApiMessagesTemplatesIdResponse> => {
  
  const res = await fetch(getGetApiMessagesTemplatesIdUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
)

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  
  const data: getApiMessagesTemplatesIdResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as getApiMessagesTemplatesIdResponse
}





export const getGetApiMessagesTemplatesIdQueryKey = (id: string,) => {
    return [
    `/api/messages/templates/${id}`
    ] as const;
    }

    
export const getGetApiMessagesTemplatesIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiMessagesTemplatesId>>, TError = unknown>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiMessagesTemplatesId>>, TError, TData>, fetch?: RequestInit}
) => {

const {query: queryOptions, fetch: fetchOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiMessagesTemplatesIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiMessagesTemplatesId>>> = ({ signal }) => getApiMessagesTemplatesId(id, { signal, ...fetchOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiMessagesTemplatesId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiMessagesTemplatesIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiMessagesTemplatesId>>>
export type GetApiMessagesTemplatesIdQueryError = unknown


/**
 * @summary Get template detail
 */

export function useGetApiMessagesTemplatesId<TData = Awaited<ReturnType<typeof getApiMessagesTemplatesId>>, TError = unknown>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiMessagesTemplatesId>>, TError, TData>, fetch?: RequestInit}
  
 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetApiMessagesTemplatesIdQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}





/**
 * @summary Update template
 */
export type putApiMessagesTemplatesIdResponse200 = {
  data: Template
  status: 200
}

export type putApiMessagesTemplatesIdResponseSuccess = (putApiMessagesTemplatesIdResponse200) & {
  headers: Headers;
};
;

export type putApiMessagesTemplatesIdResponse = (putApiMessagesTemplatesIdResponseSuccess)

export const getPutApiMessagesTemplatesIdUrl = (id: string,) => {


  

  return `/api/messages/templates/${id}`
}

export const putApiMessagesTemplatesId = async (id: string,
    updateTemplateBody: UpdateTemplateBody, options?: RequestInit): Promise<putApiMessagesTemplatesIdResponse> => {
  
  const res = await fetch(getPutApiMessagesTemplatesIdUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      updateTemplateBody,)
  }
)

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  
  const data: putApiMessagesTemplatesIdResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as putApiMessagesTemplatesIdResponse
}




export const getPutApiMessagesTemplatesIdMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiMessagesTemplatesId>>, TError,{id: string;data: UpdateTemplateBody}, TContext>, fetch?: RequestInit}
): UseMutationOptions<Awaited<ReturnType<typeof putApiMessagesTemplatesId>>, TError,{id: string;data: UpdateTemplateBody}, TContext> => {

const mutationKey = ['putApiMessagesTemplatesId'];
const {mutation: mutationOptions, fetch: fetchOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, fetch: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putApiMessagesTemplatesId>>, {id: string;data: UpdateTemplateBody}> = (props) => {
          const {id,data} = props ?? {};

          return  putApiMessagesTemplatesId(id,data,fetchOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type PutApiMessagesTemplatesIdMutationResult = NonNullable<Awaited<ReturnType<typeof putApiMessagesTemplatesId>>>
    export type PutApiMessagesTemplatesIdMutationBody = UpdateTemplateBody
    export type PutApiMessagesTemplatesIdMutationError = unknown

    /**
 * @summary Update template
 */
export const usePutApiMessagesTemplatesId = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putApiMessagesTemplatesId>>, TError,{id: string;data: UpdateTemplateBody}, TContext>, fetch?: RequestInit}
 ): UseMutationResult<
        Awaited<ReturnType<typeof putApiMessagesTemplatesId>>,
        TError,
        {id: string;data: UpdateTemplateBody},
        TContext
      > => {
      return useMutation(getPutApiMessagesTemplatesIdMutationOptions(options));
    }
    
/**
 * @summary Delete template
 */
export type deleteApiMessagesTemplatesIdResponse200 = {
  data: DeleteApiMessagesTemplatesId200
  status: 200
}

export type deleteApiMessagesTemplatesIdResponseSuccess = (deleteApiMessagesTemplatesIdResponse200) & {
  headers: Headers;
};
;

export type deleteApiMessagesTemplatesIdResponse = (deleteApiMessagesTemplatesIdResponseSuccess)

export const getDeleteApiMessagesTemplatesIdUrl = (id: string,) => {


  

  return `/api/messages/templates/${id}`
}

export const deleteApiMessagesTemplatesId = async (id: string, options?: RequestInit): Promise<deleteApiMessagesTemplatesIdResponse> => {
  
  const res = await fetch(getDeleteApiMessagesTemplatesIdUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
)

  const body = [204, 205, 304].includes(res.status) ? null : await res.text();
  
  const data: deleteApiMessagesTemplatesIdResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as deleteApiMessagesTemplatesIdResponse
}




export const getDeleteApiMessagesTemplatesIdMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiMessagesTemplatesId>>, TError,{id: string}, TContext>, fetch?: RequestInit}
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiMessagesTemplatesId>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteApiMessagesTemplatesId'];
const {mutation: mutationOptions, fetch: fetchOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, fetch: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiMessagesTemplatesId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteApiMessagesTemplatesId(id,fetchOptions)
        }



        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiMessagesTemplatesIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiMessagesTemplatesId>>>
    
    export type DeleteApiMessagesTemplatesIdMutationError = unknown

    /**
 * @summary Delete template
 */
export const useDeleteApiMessagesTemplatesId = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiMessagesTemplatesId>>, TError,{id: string}, TContext>, fetch?: RequestInit}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiMessagesTemplatesId>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getDeleteApiMessagesTemplatesIdMutationOptions(options));
    }
    
